import * as React from 'react';
import { ITerbreItemResponse } from "@/services/mixCutDetail/mixCutDetail";
import "./TimbreCard.less";
import HornIcon from '@/assets/images/music.gif';
import { Select, Message } from '@arco-design/web-react'
const Option = Select.Option;
// 全局变量存储当前播放的音频实例和对应的组件引用
let currentPlayingAudio: {audio: HTMLAudioElement; stopCallback: () => void} | null = null;
export type TimbreCardDataType = Partial<
  Pick<
    ITerbreItemResponse,
    "name" | "speaker_style" | "url" | "id" | "speaker_id" | "gender" | "cluster" | "address" | "demo_url" | "emotions" | "speed_ratio" | "volume_ratio" | "pitch_ratio" | "lang"
  >
>;
import manImg from '@/assets/create-space/man.jpg'
import womenImg from '@/assets/create-space/woman.jpg'
import checkIcon from '@/assets/quick-img/check.png'
import {getUserAvatarUrl} from "@/services/user/user";
import QuickStore from "@/stores/quickCutStore";
import { observer } from "mobx-react";
import useAudioPlayer from "@/requestHooks/mixCutDetail/useAudioPlayer";
export interface ITimbreCard {
  data: TimbreCardDataType & { address?: string };
  active: boolean;
  onClick: () => void;
  activeType?: number;
}
const langObjText = {
  'cn': '欢迎使用专属音色,我是您的配音小助手,希望未来可以一起好好相处哦',
  'en': 'Welcome to the exclusive voice feature, I am your personal assistant, and I hope we can get along well in the future',
  'ja': '専用ボイスでお使いいただけます。私はあなたの専属アシスタントです。今後もよろしくお願いします',
  'ko-KR': '전용 음색을 사용해 주셔서 감사합니다. 저는 여러분의 채용 챗봇입니다. 앞으로 잘 지내길 바랍니다.'
}
const TimbreCard: React.FC<ITimbreCard> = (props) => {
  const { active, onClick, data, activeType } = props;
  const audioRef = React.useRef<HTMLAudioElement | null>(null);
  const [isPlay, setIsPlaying] = React.useState<boolean>(false);
  const {
    isPlaying,
    stopAudio,
    playAudio,
    loading: isLoading,
  } = useAudioPlayer();
  // 清理音频资源
  const cleanupAudio = () => {
    if (audioRef.current) {
      if (currentPlayingAudio?.audio === audioRef.current) {
        currentPlayingAudio = null;
      }
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current = null;
    }
  };

  // 清理所有正在播放的音频
  const stopAllAudios = () => {
    if (currentPlayingAudio) {
      currentPlayingAudio.audio.pause();
      currentPlayingAudio.audio.currentTime = 0;
      currentPlayingAudio.stopCallback();
      currentPlayingAudio = null;
    }
  };

  const handlePlayAudio = async (e: React.MouseEvent) => {
    e.stopPropagation();
    // 如果点击的是当前正在播放的音频，则停止播放
    if (isPlaying && audioRef.current) {
      cleanupAudio();
      return;
    }

    // 停止所有正在播放的音频
    stopAllAudios();
    if (activeType === 6) {
      const result = await getUserAvatarUrl(data?.demo_url)
      audioRef.current = new Audio(result?.data.url);
    } else {
      audioRef.current = new Audio(data.address);
    }
    // 创建新的音频实例
    // audioRef.current = new Audio(data.address);

    // 清理之前的音频
    stopAllAudios();

    // 设置当前播放的音频
    currentPlayingAudio = {
      audio: audioRef.current,
      stopCallback: () => setIsPlaying(false)
    };

    // 设置播放结束后的回调
    audioRef.current.onended = () => {
      setIsPlaying(false);
      if (currentPlayingAudio?.audio === audioRef.current) {
        currentPlayingAudio = null;
      }
    };

    // 播放音频
    audioRef.current.play()
      .then(() => {
        setIsPlaying(true);
      })
      .catch(error => {
        console.error('播放失败:', error);
        setIsPlaying(false);
        if (currentPlayingAudio?.audio === audioRef.current) {
          currentPlayingAudio = null;
        }
      });
  };

  // 组件卸载时清理音频
  React.useEffect(() => {
    return () => {
      if (audioRef.current) {
        if (currentPlayingAudio?.audio === audioRef.current) {
          currentPlayingAudio = null;
        }
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, []);

  const getCheckedValue = () => {
    if (QuickStore.quickcutData.settings.copy.voice.speaker?.length > 0) {
      const obj = QuickStore.quickcutData.settings.copy.voice.speaker.find(item => item.speaker_id === data.speaker_id);
      if (obj) {
        return obj.emotion;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  return (
    <div className={`${active ? "active" : ""} timbre-card1`} onClick={(e) => {
      e.stopPropagation();
      onClick();
    }}>
      <img
        onClick={async(e) => {
          e.stopPropagation();
          const result = getCheckedValue()
          if (result) {
            cleanupAudio();
            stopAudio();
            setIsPlaying(false);
            await playAudio(
              {
                line: `<speak>${langObjText[data.lang]}</speak>`,
                speaker_id: data.speaker_id,
                speed_ratio: QuickStore.quickcutData.settings.copy.voice.speed_ratio,
                volume_ratio: QuickStore.quickcutData.settings.copy.voice.volume_ratio,
                pitch_ratio: QuickStore.quickcutData.settings.copy.voice.pitch_ratio,
                emotion: getCheckedValue()
              },
              "official"
            );
          } else {
            handlePlayAudio(e)
            setIsPlaying(false);
            stopAudio();
          }
        }}
        src={data.url || (Number(data.gender) === 1 ? manImg : womenImg)}
        alt=""
        style={{ cursor: data?.address ? 'pointer' : 'default' }}
      />
      {(isPlay || isPlaying) && (
        <div
          className='horn-icon-wrapper'
          onClick={(e) => {
            setIsPlaying(false);
            e.stopPropagation();
            if (audioRef.current) {
              cleanupAudio();
            }
            stopAudio();
          }}
        >
          <div>{isPlay}</div>
          <div>{isPlaying}</div>
          <img className="horn-icon" src={HornIcon} alt="" />
        </div>
      )}
      {
        active ? <div className={'checkicon'}>
          <img src={checkIcon} style={{width: 18, height: 18}} alt=""/>
        </div> : <div className={'no-check'}/>
      }
      <div className="timbre-msg">
        <div className="title">{data.speaker_style ? data.speaker_style : "无"}</div>
        {
  data?.emotions ? (
    <div
      onClick={(e) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
      }}
    >
      <Select
        value={getCheckedValue()}
        onChange={(value) => {
          if (QuickStore.quickcutData.settings.copy.voice.speaker?.length > 0) {
            QuickStore.quickcutData.settings.copy.voice.speaker.forEach((item) => {
              if (item.speaker_id === data.speaker_id) {
                console.log(item, 'item测试');
                item.emotion = value;
              }
            });
          }
        }}
        style={{ width: 72 }}
        onClick={(e) => {
          e.stopPropagation();
          e.nativeEvent.stopImmediatePropagation();
        }}
        dropdownRender={(menu) => (
          <div onClick={(e) => {
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
          }}>
            {menu}
          </div>
        )}
      >
        {JSON.parse(data?.emotions).map(item => (
          <Option key={item.key} value={item.key}>{item.label}</Option>
        ))}
      </Select>
    </div>
  ) : (
    <div className={'no-emotions'}>-</div>
  )
}
      </div>
    </div>
  );
};

export default observer(TimbreCard);
